// extracted by mini-css-extract-plugin
module.exports = {"item__content":"item__content__3uK88","attribute__chip":"attribute__chip__39bvM"};